import * as Config from './config';
import * as Strings from '../Locales/en.json';

class State {
    /**
     * Application State
     * 
     * @constructor
     * @constructs State
     */
    constructor() {
        this.currentUserPosition = {};
        this.position = {};
        this.pharmacies = [];
        this.DEFAULT_LOCATION = Config.DEFAULT_LOCATION;
        this.drugs = [];
        this.drugFetchAttempts = 0;
        this.map;
        this.placesService;
        this.selectedDrug;
        this.currentLocationMarker;
        this.searchLocationMarker;
        this.addressLookup;
    }

    /**
     * Returns the location for searching for a provider.
     * 
     * User selected location -> User's Current Location -> Default Location
     */
    getLocationForSearch() {
        if (!_.isEmpty(this.position)) {
            return this.position;
        } else if (!_.isEmpty(this.currentUserPosition)) {
            return this.currentUserPosition;
        } else {
            return this.DEFAULT_LOCATION;
        }
    }

    /**
     * Attempts to return a state property, or returns the error if it doesn't exist.
     * 
     * @returns {marker} A Google Maps Marker object
     */
    getMarker(location) {
        return this[location];
    }

    /**
     * Returns the state
     * 
     * @returns {State};
     */
    getState() {
        return this;
    }
}

// Initializes state
var state = new State();


export default state;


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/state.js